import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconQuestionMark20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconQuestionMark20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.726 6.447c.182-.704.538-1.377 1.09-1.87.539-.481 1.306-.827 2.395-.827 1.093 0 1.819.347 2.28.868.474.535.759 1.355.759 2.456 0 1.054-.723 1.822-1.763 2.798l-.108.101c-.456.426-.961.9-1.353 1.417-.434.576-.776 1.268-.776 2.11a.75.75 0 0 0 1.5 0c0-.408.158-.788.474-1.206.31-.41.723-.798 1.206-1.25l.083-.078.005-.005c.96-.899 2.232-2.092 2.232-3.887 0-1.343-.347-2.56-1.136-3.45-.802-.906-1.971-1.374-3.404-1.374-1.437 0-2.565.469-3.394 1.21C6 4.19 5.513 5.145 5.274 6.071a.75.75 0 0 0 1.452.375M10 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconQuestionMark20);
